import Vue from 'vue';
import Vuex from 'vuex';

// modules
import kernel from './modules/kernel.module';
import location from './modules/location.module';
import license from './modules/license.module';
import subscription from './modules/subscription.module';
import agreement from './modules/agreement.module';
import invoice from './modules/invoice.module';
import storecMobiel from './modules/storecMobiel.module';

// misc
import alert from './modules/alert.module';
import routes from './modules/routes.module';
import account from './modules/account.module';

Vue.use(Vuex);

const store = new Vuex.Store({
    modules: {
        alert,
        kernel,
        location,
        license,
        subscription,
        agreement,
        invoice,
        storecMobiel,
        routes,
        account,
    },
});

export default store;
